import React, { Component } from "react";
import "react-vertical-timeline-component/style.min.css";
import "./TimeItem.css";

export class TimeItem extends Component {
  render() {
    const {
      time: { title, date, dateEnd, image, side },
    } = this.props;
    return (
        <div className={"timeContainer " + side}>
            <div className="content">
                <div className="containerImage">
                    <img src={image} alt=""/>
                </div>
                <div className="containerText">
                    <h3>{title}</h3>
                    <p>{date + " -  " + dateEnd}</p>
                </div>
            </div>
        </div>
    );
  }
}

export default TimeItem;
